import { Avatar, Box, Chip, Grid, Paper, TableRow, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useStyles } from 'tss-react/mui';
import { addNewRole, getAvailableAccess, getMemberByMobileNumber } from '../Redux/Actions/action';
import ErrorHandler, { capitalizeFirstLetterOfWords, CommonChip } from '../Utils/handler';
import { showLoader } from '../Redux/Slices/loaderSlice';
import { toast } from 'react-toastify';
import CommonSearchField from '../Components/Common/CommonSearchField';
import CommonTable from '../Components/Common/CommonTable';
import StyledTableCell from '../Components/Common/styledTableCell';
import DataNotFound from '../Components/Common/DataNotFound';
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { BucketURL } from '../ApiSetup/Api';
import dayjs from 'dayjs';
import ButtonContained from '../Components/Common/ButtonContained';
import CustomDialog from '../Components/Common/CustomDialog';
import CommonDropDown from '../Components/Common/CommonDropDown';
import { userType } from '../Utils/enum';
import TextLabel from '../Components/Common/CommonTextLabel';
import { useLocation } from 'react-router';
import { useNavigate } from 'react-router-dom';
import CustomPagination from '../Components/Common/CommonPagination';

const tableHeaders = [
    "No",
    "Photo",
    "PPSK ID",
    "Name",
    "Mobile No",
    "Gender",
    "Submitted Date",
    "Updated Date",
    "Payment Date",
    "Start Date",
    "End Date",
    "Remaining Renew Days",
    "Status"
    // "Add New Role"
]
const MemberSearch = () => {
    // ---------- Hook -----------
    const { classes } = useStyles();
    const theme = useTheme();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const search = queryParams.get("searchText"); // gets the searchText
    // const location = useLocation();
    // const queryParams = new URLSearchParams(location.search);
    // const role = queryParams.get("role"); // gets the role


    // --------------- State -------------
    const [data, setData] = React.useState();
    const [totalCount, setTotalCount] = React.useState(0);
    const [searchText, setSearchText] = React.useState("");
    const [page, setPage] = React.useState(1);
    const [rowsPerPage, setRowsPerPage] = React.useState(25);
    // const [open, setOpen] = React.useState(false);
    // const [roleData, setRoleData] = React.useState({ role: "" });
    // const [error, setError] = React.useState({});
    // const [selectUser, setSelectUser] = React.useState({});
    const [sorting, setSorting] = useState({
        isPpskId: "",
        isSubmittedDate: "",
        isUpdatedDate: "",
        isRenewDays: "",
        isVerifyBy: "",
        isPaymentDate: ""
    });

    // Pagination handlers
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(1);
    };


    // --------------- handleChange ---------------
    // const handleClear = () => {
    //     setOpen(false);
    //     setError({});
    //     setRoleData({});
    //     setSelectUser({});
    // };

    // --------------- Api  ---------------
    const _getMemberByMobileNumber = async () => {
        dispatch(showLoader(true))
        let body = {
            search: searchText || '',
            page: page,
            limit: rowsPerPage,
            isPpskId: sorting?.isPpskId ? +sorting?.isPpskId : "",
            isSubmittedDate: sorting?.isSubmittedDate ? +sorting?.isSubmittedDate : "",
            isUpdatedDate: sorting?.isUpdatedDate ? +sorting?.isUpdatedDate : "",
            isRenewDays: sorting?.isRenewDays ? +sorting?.isRenewDays : "",
            isVerifyBy: sorting?.isVerifyBy ? +sorting?.isVerifyBy : "",
            isPaymentDate: sorting?.isPaymentDate ? +sorting?.isPaymentDate : "",
        }
        try {
            const result = await dispatch(getMemberByMobileNumber(body));
            const error = ErrorHandler(result);
            if (error) {
                setData(result?.payload?.data?.response || []);
                setTotalCount(result?.payload?.data?.count || 0);
            }
        } catch (error) {
            toast.error(error);
        } finally {
            dispatch(showLoader(false));
        }
    }

    // const _assignNewRole = async () => {
    //     if (!roleData?.role) {
    //         setError({ role: "please select any one role" })
    //         return
    //     }
    //     return
    //     dispatch(showLoader(true))
    //     try {
    //         let body = {
    //             "role": userType?.find((val) => val?.name === roleData?.role)?.value,
    //             "UserId": roleData?.role
    //         }
    //         const result = await dispatch(addNewRole(body))
    //         const error = ErrorHandler(result)
    //         if (error) {
    //             toast.success(result?.payload?.message);
    //             _getMemberByMobileNumber();
    //             handleClear();
    //         }
    //     } catch (error) {
    //         toast.error(error?.message || "An unknown error occurred");
    //     } finally {
    //         dispatch(showLoader(false))
    //     }
    // }

    // ---------- useEffect ---------

    // useEffect(() => {
    //     if (searchText) _getMemberByMobileNumber();
    // }, [searchText])

    useEffect(() => {
        dispatch(showLoader(true));
        dispatch(getAvailableAccess())
            .unwrap() // Automatically handles async response
            .catch((error) => console.error("error", error))
            .finally(() => dispatch(showLoader(false)));
    }, [dispatch]);

    useEffect(() => {
        // Always load data - with or without search text
        const timer = setTimeout(() => {
            _getMemberByMobileNumber();
        }, searchText ? 500 : 0); // Debounce only when searching
        return () => clearTimeout(timer);
    }, [searchText, sorting, page, rowsPerPage])

    useEffect(() => {
        setSearchText(search)
    }, [search])

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Paper elevation={0} sx={{ padding: 2, background: { md: "#fff", xs: "none" }, borderRadius: '20px', border: `1px solid lightgrey` }}>
                        <Box display={"flex"} justifyContent={"space-between"} alignItems={{ sm: "center", xs: "start" }} mb={2} gap={2} flexDirection={{ sm: "row", xs: "column" }}>
                            <Typography sx={{ fontSize: { lg: 24, md: 20, xs: 18 } }} fontWeight={"medium"} color={"#3E4094"}>Member Search</Typography>
                            <CommonSearchField value={searchText || search} placeholder={"Search.."} tooltipList={["Full Name", "Mobile Number", "Aadhar Number"]} handleSearch={(e) => { setSearchText(e); navigate(`/admin/memberSearch?searchText=${e}`) }} />
                        </Box>

                        <CommonTable headerList={tableHeaders} align={'center'} minWidth={600} setSorting={setSorting} sorting={sorting}>

                            {data?.length > 0 ? data?.map((document, index) => {
                                let image = document?.personalDetails?.image ? BucketURL + document?.personalDetails?.image : "No"
                                return (
                                    <TableRow key={index} onClick={() => navigate(`/admin/documents-view?id=${document._id}&searchText=${searchText}`)} sx={{ cursor: 'pointer' }}>

                                        <StyledTableCell sx={{ position: "relative", padding: "0px", width: "75px" }} align="center">
                                            <Box >
                                                {(index % rowsPerPage) + 1 + (page - 1) * rowsPerPage}
                                            </Box>
                                        </StyledTableCell>
                                        <StyledTableCell align="center" >
                                            <Box display={'flex'} justifyContent={'center'}>
                                                <Avatar src={image} slotProps={{ img: { loading: 'lazy', } }} sx={{ borderRadius: '6px' }} />
                                            </Box>
                                        </StyledTableCell>
                                        <StyledTableCell align="center">{document?.ppskId || "-"}</StyledTableCell>
                                        <StyledTableCell align="center">{capitalizeFirstLetterOfWords(document?.fullName || "-")}</StyledTableCell>
                                        <StyledTableCell align="center">{document?.phoneNumber ? document?.phoneNumber : document?.personalDetails?.phoneNumber ? document?.personalDetails?.phoneNumber : "-"}</StyledTableCell>

                                        <StyledTableCell align="center" sx={{ textTransform: 'capitalize' }}>{capitalizeFirstLetterOfWords(document?.personalDetails?.gender || "-")}</StyledTableCell>
                                        <StyledTableCell align="center">{dayjs(document?.createdAt).format("ll") || "-"}</StyledTableCell>
                                        <StyledTableCell align="center">{dayjs(document?.updatedAt).format("ll") || ""}</StyledTableCell>
                                        <StyledTableCell align="center">{document?.policyStatus?.transactionDate ? dayjs(document?.policyStatus?.transactionDate).format("ll") : "-"}</StyledTableCell>
                                        <StyledTableCell align="center">{document?.policyStatus?.activeAt ? dayjs(document?.policyStatus?.activeAt).format("ll") : "-"}</StyledTableCell>
                                        <StyledTableCell align="center">{document?.policyStatus?.expireAt ? dayjs(document?.policyStatus?.expireAt).format("ll") : "-"}</StyledTableCell>
                                        <StyledTableCell align="center">
                                            {document?.policyStatus?.remainingRenewDays ? document?.policyStatus?.remainingRenewDays + " days left" : "-"}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            <CommonChip label={document?.verificationStatus} status={document?.verificationStatus} />
                                        </StyledTableCell>
                                        {/* <StyledTableCell align="center">

                                            <ButtonContained
                                                text={"Add Role"}
                                                fontSize={{ xs: "13px", md: "14px" }}
                                                height={"35px"}
                                                onClick={() => { setOpen(true); setSelectUser(document) }}
                                            />

                                        </StyledTableCell> */}


                                    </TableRow>
                                )
                            }) :
                                (
                                    <TableRow>
                                        <StyledTableCell colSpan={13}>
                                            <DataNotFound title={'No Records Found'} icon={<ErrorOutlineIcon color="primary" style={{ fontSize: "3rem" }} />} elevation={0} />
                                        </StyledTableCell>
                                    </TableRow>
                                )
                            }

                        </CommonTable>

                        {/* Pagination */}
                        {totalCount > 0 && (
                            <Box mt={2}>
                                <CustomPagination
                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                    count={totalCount}
                                    page={page}
                                    rowsPerPage={rowsPerPage}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </Box>
                        )}

                    </Paper>
                </Grid>

                {/* {open && <CustomDialog
                    isOpen={open} handleClose={handleClear} title={"Add New Role"} padding={'10px'}
                    width={400}
                    action={
                        <>
                            <ButtonContained
                                text={"Add"}
                                onClick={_assignNewRole}
                                minWidth={'100%'}
                                marginTop={'10px'}
                            />
                        </>
                    }
                >
                    <Grid container spacing={2} xs={12}>
                        <Grid item xs={12}>
                            <CommonDropDown
                                type="text"
                                text={'Select Role'}
                                labelColor={theme.palette.primary.main}
                                name={'role'}
                                value={roleData?.role || ""}
                                // values={userType?.map((e) => e?.name) || []}
                                values={
                                    userType?.filter((item) => ![selectUser?.userType]?.includes(item?.value))
                                        ?.map((e) => e?.name) || []
                                }
                                placeholder={`Select role`}
                                width={"100%"}
                                valid
                                onChange={(e) => {
                                    const { value } = e?.target
                                    setRoleData((prevValue) => ({
                                        ...prevValue, role: value,
                                    }));
                                }}
                            />
                            <TextLabel color="error" title={!roleData?.role ? error?.role : ""} />
                        </Grid>
                    </Grid>
                </CustomDialog>} */}

            </Grid >
        </>
    )
}

export default MemberSearch
